/**
 * A guarda de saída: a tela com alteração não salva segura a troca de tela.
 *
 * Quem troca de tela (o menu, o voltar do navegador) chama `sairDaTela` com o
 * que faria. Sem guarda, faz na hora. Com guarda, entrega a ela o `seguir`, e
 * ela decide: devolve `true` quando segurou (abriu a pergunta, e chama
 * `seguir` depois, se a pessoa sair), ou `false` para deixar passar.
 *
 * Uma guarda por vez, a da tela aberta: registrar troca a anterior, e o
 * `desregistrar` devolvido só tira a própria.
 */

export type GuardaDeSaida = (seguir: () => void) => boolean;

let guarda: GuardaDeSaida | null = null;

export function registrarGuardaDeSaida(nova: GuardaDeSaida): () => void {
  guarda = nova;
  return () => {
    if (guarda === nova) guarda = null;
  };
}

/** Troca de tela, se a guarda deixar; o `seguir` dado à guarda não passa por ela de novo. */
export function sairDaTela(seguir: () => void): void {
  if (guarda?.(seguir)) return;
  seguir();
}
